//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Alert dismissing time
     */
    time: {
      type: Number,
      default: 0
    },
    /**
     * Alert dismissing time
     */
    variant: {
      type: String,
      default: 'success'
    },
    /**
     * Alert text
     */
    text: {
      type: String,
      default: 'success'
    }
  },
  data () {
    return {
      dismissCountDown: this.time
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    }
  }
}
